import emailMask from 'text-mask-addons/dist/emailMask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const maskTypeToMaskProps = {
  phone: {
    mask: ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  },
  date: {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('mm/dd/yyyy'),
  },
  currency: {
    mask: createNumberMask({}),
  },
  zip: {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/]
  },
  accountNumber: {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]
  },
  dollars: {
    mask: createNumberMask({
        prefix: '$ ',
        includeThousandsSeparator: true
    }),
  },
  // don't use guide prop with email
  email: {
    mask: emailMask,
  },
};

export default function getMaskProps(maskType) {
  const maskProps = maskTypeToMaskProps[maskType];

  if (maskProps) return maskProps;

  return false;
}



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/TextField/utils/getMaskProps.js